import React, {useCallback} from 'react'
import { Subheader } from '../../Page/logix2020/Subheader'
import { useTranslation } from 'react-i18next'
import { GoBackBtn } from '../../Buttons/GoBackBtn'
import { useWithdrawalsState } from '../../../stores/WithdrawalsProvider.js'
import { useParams } from 'react-router-dom'
import { useNavigate } from 'react-router-dom'

const PickingControlSubheader = () => {
  const { t } = useTranslation()
  const { unlockShippingOrder } = useWithdrawalsState()
  const { soId } = useParams()
  const navigate = useNavigate();
  const handleGoBack = useCallback(async soId => {
    await unlockShippingOrder(soId)
    navigate("/localstorage/withdrawals")
  }, [unlockShippingOrder, navigate])
  return (
    <Subheader className="subHeader-v1">
      <div className="flex-grow-1">
        <div>
          <GoBackBtn color="white" /*to="/localstorage/withdrawals"*/
                                          onClick={(e) => {
                                            e.stopPropagation();
                                            handleGoBack(soId);
                                        }}
          >
            {t('withdrawalPage:overviewWithdrawal')}
          </GoBackBtn>
          <div className="subheader-title-small">{t('withdrawalPage:pickingControl')} </div>
        </div>
      </div>
    </Subheader>
  )
}

export default PickingControlSubheader